import i18n from 'i18next';

export const FIELDS = [
	{
		name: 'ip_address',
		type: 'text',
		label: i18n.t('ip_verification:form.ip_address')
	}
];
